import { Stack } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import "../../common/styles/common.scss";
import { getCase } from "../../services/cases";
import { casesLinks, getKeyFromText } from "../../utils/Utilities";
const SideBar = ({ data }) => {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <>
      <Stack className="cases-side-bar">
        {casesLinks(data).map((item) => (
          <Link
            key={item.id}
            to={item.to}
            className={`side-link${
              location.pathname === item.route ? " active" : ""
            }`}
          >
            <p>{t(getKeyFromText(item.name))}</p>
            <div className={item.id === 3 ? "badge-red" : "badge"}>
              {item.list.length}
            </div>
          </Link>
        ))}
      </Stack>
    </>
  );
};

export default SideBar;
